
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30142',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30142",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54318",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7937",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11383",
  "I18n": "static-7.1606",
  "quartz": "static-1.6900",
  "quartz-config": "static-1.678",
  "quartz-core": "static-1.6119",
  "react-dlb": "static-1.77",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.773",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54305",
  "feedback-utils": "static-1.54309",
  "forms-embed-utils-lib": "static-1.4386",
  "forms-utils-lib": "static-1.12435",
  "foundations-assets": "static-1.4775",
  "foundations-components": "static-1.7779",
  "foundations-theming": "static-1.4338",
  "hub-http": "static-1.6145",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11691",
  "icons": "static-2.640",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3857",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16583",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5283",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57254",
  "transmute": "static-2.85",
  "ui-images": "static-2.1133",
  "UIComponents": "static-3.8330",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3341",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3177",
  "quartz-webpack": "static-1.3124",
  "foundations-theming-specialty": "static-1.2054",
  "property-description-translator": "static-1.3773",
  "HeadJS": "static-2.737",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3048",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4248",
  "jasmine-runner": "static-1.6392",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.822",
  "hubspotter-http": "static-1.4591",
  "mobile-manifest-mixins": "static-1.511",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.575",
  "quartz-head": "static-1.565",
  "quartz-i18n": "static-1.575",
  "quartz-routing": "static-1.330",
  "quartz-test": "static-1.575",
  "quartz-tracking": "static-1.279",
  "ui-fonts": "static-1.645",
  "usage-tracker-container": "static-1.7250",
  "usage-tracker-core": "static-1.7110",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7174",
  "reference-resolvers": "static-1.8093",
  "sanitize-text": "static-1.8069",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10298",
  "sanitize": "static-1.4397",
  "outpost": "static-1.4114",
  "rpc-client-utils": "static-1.4569",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4048",
  "floating-ui": "static-1.54",
  "hs-story-utils": "static-1.9354",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1595",
  "bend-plugin-foundations-theming": "static-1.2821",
  "foundations-theming-base": "static-1.3323",
  "stylex": "static-1.30",
  "hs-locale-management": "static-1.23",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8744",
  "atom": "static-1.4995",
  "codemirror": "static-5.93",
  "content-assistance-lib": "static-1.7638",
  "ContentUtils": "static-1.68117",
  "data-token-picker": "static-1.16270",
  "file-manager-components": "static-1.23375",
  "FileManagerCore": "static-1.38874",
  "FileManagerLib": "static-1.39015",
  "frontend-preferences-client": "static-1.7850",
  "hub-http-contrib": "static-1.2966",
  "interframe": "static-3.4687",
  "layout-dnd-components": "static-1.12297",
  "layout-dnd-utils": "static-1.11272",
  "property-translator": "static-1.5328",
  "react-codemirror": "static-1.10548",
  "react-colorpicker": "static-2.10134",
  "reference-resolvers-lite": "static-1.8016",
  "rich-text-lib": "static-1.19699",
  "tinymce-data": "static-1.40225",
  "tinymce-themes": "static-1.56110",
  "ui-addon-emoji-picker": "static-1.9811",
  "ui-addon-sales-email": "static-1.5136",
  "ui-brand-identity-lib": "static-1.14898",
  "bender-build-tools": "static-1.3093",
  "hub-http-shared-msw-handlers": "static-1.9784",
  "hubspotter-http-shared-msw-handlers": "static-1.9782",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4946",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1807",
  "chatspot-core": "static-1.20927",
  "copilot-toolkit": "static-1.10911",
  "data-fetching-client": "static-1.9599",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4693",
  "ui-addon-video-player": "static-1.8621",
  "ui-coaching-tips": "static-1.28320",
  "usage-tracker": "static-1.7260",
  "cms-field-types": "static-1.4734",
  "content-icons-ui": "static-1.2206",
  "integrations-lib": "static-1.15861",
  "customer-data-objects": "static-1.7585",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4575",
  "apollo-stack-hubspot": "static-3.84",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "immerable": "static-1.4077",
  "ui-addon-iframeable": "static-1.8975",
  "video-components-external": "static-1.11023",
  "video-data-lib": "static-1.34681",
  "audio-components": "static-1.5801",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29157",
  "FileManagerImages": "static-1.36526",
  "foundations-components-legacy": "static-1.804",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.523",
  "ui-universal-auth": "static-1.8878",
  "urlinator": "static-1.4456",
  "video-components": "static-1.13026",
  "video-embed": "static-1.35515",
  "ts-schema": "static-1.4017",
  "ContentData": "static-1.68192",
  "layout-data-lib": "static-1.9597",
  "react-dnd-compat": "static-1.4544",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1477",
  "external-options-client-types": "static-1.4098",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6799",
  "hs-promise-utils": "static-1.5519",
  "inbound-db-properties-service-client": "static-1.3781",
  "NamespacedHubStyle": "static-2.9004",
  "growth-onboarding-confetti": "static-1.2994",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11074",
  "amplitude-session-replay-browser": "static-1.58",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5514",
  "magpie-types": "static-1.4974",
  "simple-logging-lib": "static-1.2975",
  "growth-onboarding-feedback-components": "static-1.6507",
  "flux-actions": "static-1.326",
  "hubspot-apollo-client": "static-1.4802",
  "integrations-error-boundary-lib": "static-1.13276",
  "integrations-tracking-lib": "static-1.5521",
  "laboratory-lib": "static-3.7083",
  "native-integrations-shared-strings": "static-1.7710",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10073",
  "unified-auth": "static-1.392",
  "navigation-messaging": "static-1.7070",
  "content-media-composition-data-lib": "static-1.11997",
  "content-media-compositions": "static-2.16004",
  "idb-keyval": "static-1.42",
  "media-bridge-lib": "static-1.18793",
  "unified-auth-core-lib": "static-1.673",
  "social-insights-client-types": "static-1.21858",
  "advanced-menus-core": "static-1.15010",
  "advanced-menus-lib": "static-1.11966",
  "ExportDialog": "static-6.10315",
  "ui-memberships-settings-lib": "static-1.33825",
  "conditional-properties-service-client": "static-1.3736",
  "crm-pipelines-api-client-types": "static-1.4082",
  "framework-builder-read-service-client": "static-1.3949",
  "framework-data-schema-quick-fetch": "static-1.6704",
  "inbound-db-meta-service-client": "static-1.3530",
  "multi-currency-client-types": "static-1.3631",
  "persist-promise": "static-1.3634",
  "foundations-components-test-utils": "static-1.5262",
  "reactive-lib": "static-1.647",
  "hubspot-apollo-cache": "static-1.261",
  "universal-page-editor-lib": "static-1.2933",
  "google-sheets-integration-lib": "static-1.5",
  "microsoft-drive-integration-lib": "static-1.96",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3658",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15009",
  "simple-menus-lib": "static-1.16526",
  "crm-record-cards-service-types": "static-1.3550",
  "location-customization-utils-lib": "static-1.9002",
  "react-flip-move": "static-1.68"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30142",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54318",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7937",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11383",
  "I18n": "/I18n/static-7.1606",
  "quartz": "/quartz/static-1.6900",
  "quartz-config": "/quartz-config/static-1.678",
  "quartz-core": "/quartz-core/static-1.6119",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.773",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54305",
  "feedback-utils": "/feedback-utils/static-1.54309",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4386",
  "forms-utils-lib": "/forms-utils-lib/static-1.12435",
  "foundations-assets": "/foundations-assets/static-1.4775",
  "foundations-components": "/foundations-components/static-1.7779",
  "foundations-theming": "/foundations-theming/static-1.4338",
  "hub-http": "/hub-http/static-1.6145",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11691",
  "icons": "/icons/static-2.640",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3857",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16583",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5283",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57254",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1133",
  "UIComponents": "/UIComponents/static-3.8330",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3341",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3177",
  "quartz-webpack": "/quartz-webpack/static-1.3124",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2054",
  "property-description-translator": "/property-description-translator/static-1.3773",
  "HeadJS": "/HeadJS/static-2.737",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3048",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4248",
  "jasmine-runner": "/jasmine-runner/static-1.6392",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.822",
  "hubspotter-http": "/hubspotter-http/static-1.4591",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.511",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.575",
  "quartz-head": "/quartz-head/static-1.565",
  "quartz-i18n": "/quartz-i18n/static-1.575",
  "quartz-routing": "/quartz-routing/static-1.330",
  "quartz-test": "/quartz-test/static-1.575",
  "quartz-tracking": "/quartz-tracking/static-1.279",
  "ui-fonts": "/ui-fonts/static-1.645",
  "usage-tracker-container": "/usage-tracker-container/static-1.7250",
  "usage-tracker-core": "/usage-tracker-core/static-1.7110",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7174",
  "reference-resolvers": "/reference-resolvers/static-1.8093",
  "sanitize-text": "/sanitize-text/static-1.8069",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10298",
  "sanitize": "/sanitize/static-1.4397",
  "outpost": "/outpost/static-1.4114",
  "rpc-client-utils": "/rpc-client-utils/static-1.4569",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4048",
  "floating-ui": "/floating-ui/static-1.54",
  "hs-story-utils": "/hs-story-utils/static-1.9354",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1595",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2821",
  "foundations-theming-base": "/foundations-theming-base/static-1.3323",
  "stylex": "/stylex/static-1.30",
  "hs-locale-management": "/hs-locale-management/static-1.23",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8744",
  "atom": "/atom/static-1.4995",
  "codemirror": "/codemirror/static-5.93",
  "content-assistance-lib": "/content-assistance-lib/static-1.7638",
  "ContentUtils": "/ContentUtils/static-1.68117",
  "data-token-picker": "/data-token-picker/static-1.16270",
  "file-manager-components": "/file-manager-components/static-1.23375",
  "FileManagerCore": "/FileManagerCore/static-1.38874",
  "FileManagerLib": "/FileManagerLib/static-1.39015",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7850",
  "hub-http-contrib": "/hub-http-contrib/static-1.2966",
  "interframe": "/interframe/static-3.4687",
  "layout-dnd-components": "/layout-dnd-components/static-1.12297",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11272",
  "property-translator": "/property-translator/static-1.5328",
  "react-codemirror": "/react-codemirror/static-1.10548",
  "react-colorpicker": "/react-colorpicker/static-2.10134",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8016",
  "rich-text-lib": "/rich-text-lib/static-1.19699",
  "tinymce-data": "/tinymce-data/static-1.40225",
  "tinymce-themes": "/tinymce-themes/static-1.56110",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9811",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5136",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14898",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9784",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9782",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4946",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1807",
  "chatspot-core": "/chatspot-core/static-1.20927",
  "copilot-toolkit": "/copilot-toolkit/static-1.10911",
  "data-fetching-client": "/data-fetching-client/static-1.9599",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4693",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8621",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28320",
  "usage-tracker": "/usage-tracker/static-1.7260",
  "cms-field-types": "/cms-field-types/static-1.4734",
  "content-icons-ui": "/content-icons-ui/static-1.2206",
  "integrations-lib": "/integrations-lib/static-1.15861",
  "customer-data-objects": "/customer-data-objects/static-1.7585",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4575",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4077",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8975",
  "video-components-external": "/video-components-external/static-1.11023",
  "video-data-lib": "/video-data-lib/static-1.34681",
  "audio-components": "/audio-components/static-1.5801",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29157",
  "FileManagerImages": "/FileManagerImages/static-1.36526",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.804",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.523",
  "ui-universal-auth": "/ui-universal-auth/static-1.8878",
  "urlinator": "/urlinator/static-1.4456",
  "video-components": "/video-components/static-1.13026",
  "video-embed": "/video-embed/static-1.35515",
  "ts-schema": "/ts-schema/static-1.4017",
  "ContentData": "/ContentData/static-1.68192",
  "layout-data-lib": "/layout-data-lib/static-1.9597",
  "react-dnd-compat": "/react-dnd-compat/static-1.4544",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1477",
  "external-options-client-types": "/external-options-client-types/static-1.4098",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6799",
  "hs-promise-utils": "/hs-promise-utils/static-1.5519",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3781",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9004",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2994",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11074",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5514",
  "magpie-types": "/magpie-types/static-1.4974",
  "simple-logging-lib": "/simple-logging-lib/static-1.2975",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6507",
  "flux-actions": "/flux-actions/static-1.326",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4802",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13276",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5521",
  "laboratory-lib": "/laboratory-lib/static-3.7083",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7710",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10073",
  "unified-auth": "/unified-auth/static-1.392",
  "navigation-messaging": "/navigation-messaging/static-1.7070",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11997",
  "content-media-compositions": "/content-media-compositions/static-2.16004",
  "idb-keyval": "/idb-keyval/static-1.42",
  "media-bridge-lib": "/media-bridge-lib/static-1.18793",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.673",
  "social-insights-client-types": "/social-insights-client-types/static-1.21858",
  "advanced-menus-core": "/advanced-menus-core/static-1.15010",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11966",
  "ExportDialog": "/ExportDialog/static-6.10315",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33825",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3736",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4082",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3949",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6704",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3530",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3631",
  "persist-promise": "/persist-promise/static-1.3634",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5262",
  "reactive-lib": "/reactive-lib/static-1.647",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.261",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2933",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.5",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.96",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3658",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15009",
  "simple-menus-lib": "/simple-menus-lib/static-1.16526",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3550",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9002",
  "react-flip-move": "/react-flip-move/static-1.68"
}
};
